export default class StripePaymentRequest {
    constructor(
        stripeObject,
        stripeElements,
        paymentProcessor,
        button,
        secret,
        amount,
        label,
        trialEndDate = null,
        recurringAmount = null,
        recurringInterval = null,
    ) {
        this.stripeObject = stripeObject;
        this.stripeElements = stripeElements;
        this.paymentProcessor = paymentProcessor;
        this.appleButton = button;
        this.clientSecret = secret;
        this.amount = amount;
        this.label = label;
        this.trialEndDate = trialEndDate;
        this.recurringAmount = recurringAmount;
        this.recurringInterval = recurringInterval;
        this.paymentRequest = null;
        this.prButton = null;
        this.loadApplePay();
    }

    sendGtmLogs(method = '') {
        window.gtmDataLayer = window.gtmDataLayer || [];
        window.gtmDataLayer.push({
            event: 'standardEvent',
            category: 'user_tag',
            action: 'payment options',
            label:
                method === ''
                    ? `${this.label} paymentRequest button loaded:true`
                    : `${this.label} with ${method}`,
        });
    }

    loadApplePay() {
        if (this.trialEndDate) {
          this.label = `${this.label} ${this.recurringAmount} ${this.recurringInterval} starting on ${this.trialEndDate}`;
        }
        this.paymentRequest = this.stripeObject.paymentRequest({
            country: 'US',
            currency: 'usd',
            total: {
                label: this.label,
                amount: this.amount,
            },
            requestPayerName: true,
            requestPayerEmail: true,
        });
        this.prButton = this.stripeElements.create('paymentRequestButton', {
            paymentRequest: this.paymentRequest,
        });

        this.paymentRequest.canMakePayment().then((result) => {
            if (result) {
                this.prButton.mount('#payment-request-button');
                this.sendGtmLogs();
            } else {
                this.appleButton.style.display = 'none';
            }
        });

        this.paymentRequest.on('paymentmethod', (ev) => {
            if (typeof this.setupIntent === 'undefined') {
                this.stripeObject
                    .confirmCardSetup(
                        this.clientSecret,
                        // eslint-disable-next-line camelcase
                        { payment_method: ev.paymentMethod.id },
                        { handleActions: false }
                    )
                    .then((confirmResult) => {
                        if (confirmResult.error) {
                            ev.complete('fail');
                        } else {
                            ev.complete('success');
                            this.sendGtmLogs(ev.methodName);
                            this.setupIntent = confirmResult.setupIntent;
                            this.paymentProcessor(
                                this.setupIntent.payment_method,
                                this.appleButton
                            );
                        }
                    });
            } else {
                this.paymentProcessor(
                    this.setupIntent.payment_method,
                    this.appleButton
                );
            }
        });
    }
}
